<template>
  <page-outline :title="$t('Webheader.faqs')">
    <template #pageContent>
      <b-container fluid v-if="!hasLinks">
        <span>{{ $t('faq.no_file') }}</span>
      </b-container>
      <b-container fluid v-else>
        <b-row>
          <!-- Colonne 1 : Guide -->
          <b-col md="3">
            <h5>{{ $t('faq.download_files.userguide') }}</h5>
            <div v-if="links.userguide">
              <label @click="getUri(links.userguide)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.user_guide') }}
              </label>
            </div>

            <div v-if="links.testcaselist">
              <label @click="getUri(links.testcaselist)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.testcaselist') }}
              </label>
            </div>

            <div v-if="links.onboardingguide">
              <label @click="getUri(links.onboardingguide)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.onboardingguide') }}
              </label>
            </div>
          </b-col>

          <!-- Colonne 2 : Vidéos -->
          <b-col md="5">
            <h5>{{ $t('faq.download_files.video') }}</h5>

            <div v-if="links.videoSettingID">
              <label @click="getUri(links.videoSettingID)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoSettingID') }}
              </label>
            </div>
            <div v-if="links.videoresponderconf1">
              <label @click="getUri(links.videoresponderconf1)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoresponderconf1') }}
              </label>
            </div>
            <div v-if="links.videoresponderconf2">
              <label @click="getUri(links.videoresponderconf2)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoresponderconf2') }}
              </label>
            </div>
            <div v-if="links.videoresponderconf">
              <label @click="getUri(links.videoresponderconf)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoresponderconf') }}
              </label>
            </div>
            <div v-if="links.videoRequesterTestCase">
              <label @click="getUri(links.videoRequesterTestCase)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoRequesterTestCase') }}
              </label>
            </div>
            <div v-if="links.videoResponderTesCase">
              <label @click="getUri(links.videoResponderTesCase)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoResponderTesCase') }}
              </label>
            </div>
            <div v-if="links.videoWiewRequests">
              <label @click="getUri(links.videoWiewRequests)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoWiewRequests') }}
              </label>
            </div>
            <div v-if="links.videoTestReport">
              <label @click="getUri(links.videoTestReport)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoTestReport') }}
              </label>
            </div>
            <div v-if="links.videotestsession">
              <label @click="getUri(links.videotestsession)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videotestsession') }}
              </label>
            </div>
            <div v-if="links.videoFAQ">
              <label @click="getUri(links.videoFAQ)" class="cursor">
                <i class="fas fa-file-video-o"/> {{ $t('faq.download_files.videoFAQ') }}
              </label>
            </div>
          </b-col>

          <!-- Colonne 3 : Fichiers exemples -->
          <b-col md="4">
            <h5>{{ $t('faq.download_files.examplesfiles') }}</h5>
            <div v-if="links.requestertestdataimportexemple">
              <label @click="getUri(links.requestertestdataimportexemple)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.requestertestdataimportexemple') }}
              </label>
            </div>
            <div v-if="links.respondertestdataimportexemple">
              <label @click="getUri(links.respondertestdataimportexemple)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.respondertestdataimportexemple') }}
              </label>
            </div>
            <div v-if="links.voprequestbicexemple">
              <label @click="getUri(links.voprequestbicexemple)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.voprequestbicexemple') }}
              </label>
            </div>
            <div v-if="links.voprequestidexemple">
              <label @click="getUri(links.voprequestidexemple)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.voprequestidexemple') }}
              </label>
            </div>
            <div v-if="links.voprequestleiexemple">
              <label @click="getUri(links.voprequestleiexemple)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.voprequestleiexemple') }}
              </label>
            </div>
            <div v-if="links.voprequestnameexemple">
              <label @click="getUri(links.voprequestnameexemple)" class="cursor">
                <i class="fas fa-file-text"/> {{ $t('faq.download_files.voprequestnameexemple') }}
              </label>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import conf from '../../config/config.dev.js'
import PageOutline from '@/components/common/PageOutline.vue'


export default {
  name: 'TrackingPage',
  components: {
    'page-outline': PageOutline,
  },
  props: {
  },
  computed: {
    hasLinks () {
      return this.links && Object.keys(this.links).length
    }
  },
  data () {
    return {
      uri: '',
      links: conf.faq
    }
  },
  created () {
  },
  mounted () {
    this.$bus.emit('set-small-panel')
  },
  beforeDestroy () {
  },
  methods: {
    click () {
      let that = this
      getUri(uri)
    },

    getUri (uri) {
      let that = this
      fetch(uri, {method: 'HEAD'})
      .then(response => {
        const link = document.createElement('a');
        link.href = uri;
        link.download = ''; // Laisser vide pour que le nom d'origine soit utilisé
        link.target = '_blank';
        link.click();
      })
      .catch(err => {
        that.$f7.alert(that.$i18n.t('faq.download_error_desc'), that.$i18n.t('faq.download_error'))
        console.log('err', err)
      })
    }
  }
}
</script>
